import camelcaseKeys from 'camelcase-keys';

export function toCamelCase(response: object | object[]) {
  return camelcaseKeys(response, { deep: true });
}
